/**
 * Retrieves the value of a specific UTM parameter from the current URL's query string.
 * 
 * @param param - The name of the UTM parameter to retrieve.
 * @returns The value of the UTM parameter, or an empty string if the parameter is not present.
 */
export const getUTMParameter = (param: string): string => {
    if (typeof window === "undefined") {
      console.error("getUTMParameter: Window object is not available.");
      return "";
    }
  
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param) ?? "";
  };
  